module.exports = __webpack_public_path__ + "static/custom-alerts-1219420c0deab1f9ac53564cbc624e97.mp4";